export default {
    namespaced: true,
    state: {
      requests: [
        {
          id: 100,
          name: 'Antrag auf Ausbildungsförderung (BAföG)',
          date: '17.11.2018',
          online: true,
          status: 'In Bearbeitung',
        },
        {
            id: 101,
            name: 'Änderung der Kontaktadressen',
            date: '17.11.2018',
            online: true,
            status: 'Abgeschlossen',
          },
          {
            id: 102,
            name: 'Reservierung Wunschkennzeichen',
            date: '17.11.2018',
            online: true,
            status: 'Abgeschlossen',
          },
          {
            id: 103,
            name: 'Antrag auf Landespflegegeld',
            date: '17.11.2018',
            online: true,
            status: 'Abgelehnt',
          },
          {
            id: 104,
            name: 'Antrag Bewohnerparkausweis',
            date: '17.11.2018',
            online: true,
            status: 'Abgeschlossen',
          },
          {
            id: 105,
            name: 'Antrag auf erweitertes Führungszeugnis',
            date: '17.11.2018',
            online: true,
            status: 'Abgeschlossen',
          },
          {
            id: 106,
            name: 'Anmeldung für Kita-Warteliste',
            date: '17.11.2018',
            online: false,
            status: 'In Bearbeitung',
          },
      ]
    },
    mutations: {
    },
    actions: {

    },
    getters: {
        getAllRequests: state => {
            return state.requests;
        },
      getRequestById: (state) => (id) => {
        return state.requests.find(request => request.id == id);
      },
      getRequestsByTitle: state => (searchTerm) => {
        return state.requests.filter(request => request.name.toLowerCase().includes(searchTerm.toLowerCase()) 
        || request.status.toLowerCase().includes(searchTerm.toLowerCase()));
      },
      getOnlineRequests: (state) => {
        return state.requests.filter(request => request.online);
      },
      getOfflineRequests: (state) => {
        return state.requests.filter(request => !request.online);
      },
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/requests.js